import React, { useState } from 'react';
import {
  Dialog,
  Grid,
  Typography,
  Icon,
  Button,
  FormHelperText
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { InputBaseField, SelectField } from '../../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements';
import { PostDataAPI } from '../../../../Services/APIService';
import { withSnackbar } from "../../../../components/Message/Alert";
import { Scrollbars } from 'rc-scrollbars';
import useStyles from "./styles";

function AddNewRight({ dialogOpenClose, handleClose, handleSuccessClose, data, roleType, showMessage }) {
  const classes = useStyles();

  const [formData, setFormData] = useState({
    rightId: data?.rightId || 0,
    rightName: data?.rightName || "",
    rightLabel: data?.rightLabel || "",
    rightDescription: data?.rightDescription || "",
    sortOrder: data?.sortOrder || "",
    roleType: data?.roleType || ""

  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" })); // clear error
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.rightName.trim()) tempErrors.rightName = "Right Name is required";
    if (!formData.rightLabel.trim()) tempErrors.rightLabel = "Right Label is required";
    if (!formData.rightDescription.trim()) tempErrors.rightDescription = "Right Description is required";
    if (!formData.sortOrder || formData.sortOrder <= 0) tempErrors.sortOrder = "Sort Order is required";
    if (!formData.roleType) tempErrors.roleType = "Role Type is required";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    let method = "fdnrights/add";
    if (formData.rightId > 0) {
      method = "fdnrights/update";
    }

    PostDataAPI(method, formData, true).then((result) => {
      if (result.success) {
        handleSuccessClose(formData.rightId > 0 ? "Right updated successfully." : "Right added successfully.");
      } else {
        showMessage("Error", result.message, "error", 3000);
      }
    });
  };

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      PaperComponent={DraggableComponent}
      disableBackdropClick
      disableEscapeKeyDown
      open={dialogOpenClose}
      maxWidth="md"
    >
      <div className={classes.dialogContent}>
        <div className={classes.box}>
          {/* Header */}
          <div className={classes.header} id="draggable-dialog-title">
            <Typography className={classes.title}>
              {formData.rightId > 0 ? "Update Right" : "Add New Right"}
            </Typography>
            <Icon className={classes.closeIcon} onClick={handleClose} color="primary">
              <CloseIcon />
            </Icon>
          </div>

          {/* Scrollable Content */}
          <Scrollbars autoHeight autoHeightMax={500}>
            <div className={classes.content}>
              <Grid container spacing={4}>
                <Grid item sm={12} md={6}>
                  <Label size={12} title="Right Name" mandatory={true} />
                  <InputBaseField
                    name="rightName"
                    value={formData.rightName}
                    onChange={handleChange}
                    placeholder="Right Name"
                    MaxLength={50}
                  />
                  {errors.rightName && <FormHelperText style={{ color: "red" }}>{errors.rightName}</FormHelperText>}
                </Grid>
                <Grid item sm={12} md={6}>
                  <Label size={12} title="Right Label" mandatory={true} />
                  <InputBaseField
                    name="rightLabel"
                    value={formData.rightLabel}
                    onChange={handleChange}
                    placeholder="Right Label"
                    MaxLength={50}
                  />
                  {errors.rightLabel && <FormHelperText style={{ color: "red" }}>{errors.rightLabel}</FormHelperText>}
                </Grid>
              </Grid>

              <Grid container spacing={4}>
                <Grid item sm={12} md={6}>
                  <Label size={12} title="Right Description" mandatory={true} />
                  <InputBaseField
                    name="rightDescription"
                    value={formData.rightDescription}
                    onChange={handleChange}
                    placeholder="Right Description"
                    MaxLength={200}
                  />
                  {errors.rightDescription && <FormHelperText style={{ color: "red" }}>{errors.rightDescription}</FormHelperText>}
                </Grid>
                <Grid item sm={12} md={6}>
                  <Label size={12} title="Sort Order" mandatory={true} />
                  <InputBaseField
                    name="sortOrder"
                    type="number"
                    value={formData.sortOrder}
                    onChange={handleChange}
                    placeholder="Sort Order"
                  />
                  {errors.sortOrder && <FormHelperText style={{ color: "red" }}>{errors.sortOrder}</FormHelperText>}
                </Grid>
              </Grid>

              <Grid container spacing={4}>
                <Grid item sm={12} md={6}>
                  <Label size={12} title="Role Type" mandatory={true} />
                  <SelectField
                    name="roleType"
                    value={formData.roleType}
                    onChange={handleChange}
                    options={[
                      { value: "", label: "Select Role Type" },   // 👈 default option
                      { value: "services_portal", label: "Services Portal" },
                      { value: "customer_portal", label: "Customer Portal" },
                    ]}
                  />
                  {errors.roleType && <FormHelperText style={{ color: "red" }}>{errors.roleType}</FormHelperText>}
                </Grid>
              </Grid>
            </div>
          </Scrollbars>

          {/* Footer */}
          <div className={classes.footer}>
            <div className={classes.footerRight}>
              <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
              <Button className={classes.changeBtn} onClick={handleSubmit}>
                {formData.rightId > 0 ? "Update" : "Add New"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default withSnackbar(AddNewRight);
